/* eslint-disable @typescript-eslint/naming-convention */
import { Modal, ModalOverlay, ModalProps } from '@chakra-ui/react'

import { AddPlayerModalContent } from './components/AddPlayerModalContent'

type AddPlayerModalProps = Omit<ModalProps, 'children'>

export function AddPlayerModal({ ...modalProps }: AddPlayerModalProps) {
    return (
        <Modal
            isOpen={modalProps.isOpen}
            onClose={() => modalProps.onClose?.()}
            size={modalProps.size}
            scrollBehavior="outside"
            returnFocusOnClose={false}>
            <ModalOverlay />
            <AddPlayerModalContent />
        </Modal>
    )
}
